// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__16tim","list":"PatternAutocomplete_list__3FYVb"};